/**
 * The one body-text treatment every public page uses (FR-303, FR-304; design
 * §54 D2, D3).
 *
 * UAT found three different body colours and two sizes across the eight
 * section renderers, because each one spelled its own classes out. The value
 * lives here so the next change is one line rather than eight files, and so
 * two renderers cannot drift apart again.
 *
 * `text-navy` rather than `text-text-primary`: both are `#001928`, but
 * `text-text-primary` flips under `data-theme="dark"`, which the admin console
 * sets on `<html>`. Public pages are light-only by design, so the
 * theme-invariant token is the honest one - and it matches the Homepage
 * "For Trusted Partners" band the client pointed at (D2).
 *
 * Scope is body PARAGRAPHS on LIGHT backgrounds. Eyebrows, subtitles, closing
 * lines and notes keep their own colours (A-341), and dark-background sections
 * keep their own `text-white` / `text-white/80` (D3) - neither belongs here.
 */
/**
 * The colour alone, for the two renderers that resolve a body class through a
 * per-section override map (`CardGridRenderer`, `CtaBannerRenderer`) and so
 * cannot take the combined class. Exported from here, not spelled out there,
 * so the override default and `PUBLIC_BODY_CLASS` cannot disagree.
 */
export const PUBLIC_BODY_COLOR = 'text-navy';

/** Size and colour together, for renderers with no per-section override. */
export const PUBLIC_BODY_CLASS = `text-p4 ${PUBLIC_BODY_COLOR}`;
